import React from "react";
import TitleStripe from "../../common/TitleStripe";
import NoOcurrence from "../../common/query/NoOcurrence";

const hasInadimplencia = (data) => {
  const status = String(data?.status || "").toLowerCase();
  return (
    Boolean(data?.possuiProcesso) ||
    Number(data?.totalProcessos || 0) > 0 ||
    status.includes("inadimplente")
  );
};

export default function CndtQuery({ data }) {
  const processos = Array.isArray(data?.processos) ? data.processos : [];
  const hasProcessos = hasInadimplencia(data);

  return (
    <section className="mt-6" id="cndt">
      <TitleStripe>
        CNDT | Certidão Negativa de Débitos Trabalhistas
      </TitleStripe>

      {data?.statusRetorno == 1 ? (
        <>
          <div className="mt-4 grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
            <div className="rounded-xl border border-gray-200 bg-gray-50 p-3">
              <p className="text-[11px] text-gray-500">Nome</p>
              <p className="text-sm font-semibold text-gray-900">
                {data?.nome || "-"}
              </p>
            </div>
            <div className="rounded-xl border border-gray-200 bg-gray-50 p-3">
              <p className="text-[11px] text-gray-500">Documento consultado</p>
              <p className="text-sm font-semibold text-gray-900">
                {data?.documentoConsultado || "-"}
              </p>
            </div>
            <div className="rounded-xl border border-gray-200 bg-gray-50 p-3">
              <p className="text-[11px] text-gray-500">Número da certidão</p>
              <p className="text-sm font-semibold text-gray-900">
                {data?.numeroCertidao || "-"}
              </p>
            </div>
            <div className="rounded-xl border border-gray-200 bg-gray-50 p-3">
              <p className="text-[11px] text-gray-500">Total de processos</p>
              <p className="text-sm font-semibold text-gray-900">
                {Number(data?.totalProcessos || 0)}
              </p>
            </div>
          </div>

          <div
            className={`mt-3 rounded-xl border ${+data?.totalProcessos > 0 ? "border-red-500 bg-red-50" : "border-blue-100 bg-blue-50"} p-3`}
          >
            <p className="text-[11px] text-blue-700">Status da certidão</p>
            <p className="text-sm font-medium text-blue-900">
              {data?.status || "-"}
            </p>
          </div>

          <div className="mt-3 grid gap-3 sm:grid-cols-2">
            <div className="rounded-xl border border-gray-200 bg-white p-3">
              <p className="text-[11px] text-gray-500">Data de expedição</p>
              <p className="text-sm font-semibold text-gray-900">
                {data?.dataExpedicao || "-"}
              </p>
            </div>
            <div className="rounded-xl border border-gray-200 bg-white p-3">
              <p className="text-[11px] text-gray-500">Data de validade</p>
              <p className="text-sm font-semibold text-gray-900">
                {data?.dataValidade || "-"}
              </p>
            </div>
          </div>

          {hasProcessos ? (
            <div className="mt-4 overflow-hidden rounded-xl border border-gray-200">
              <div className="border-b border-gray-200 bg-gray-50 px-4 py-2 text-sm font-semibold text-gray-700">
                Processos trabalhistas
              </div>

              {processos.length > 0 ? (
                <div className="overflow-x-auto">
                  <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-white">
                      <tr>
                        <th className="px-4 py-2 text-left text-xs font-semibold uppercase tracking-wide text-gray-500">
                          Código
                        </th>
                        <th className="px-4 py-2 text-left text-xs font-semibold uppercase tracking-wide text-gray-500">
                          Local
                        </th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-100 bg-white">
                      {processos.map((proc, idx) => (
                        <tr key={`${proc?.codigo || "proc"}-${idx}`}>
                          <td className="px-4 py-2 text-sm font-medium text-gray-900">
                            {proc?.codigo || "-"}
                          </td>
                          <td className="px-4 py-2 text-sm text-gray-700">
                            {proc?.local || "-"}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <div className="p-3 -mt-4">
                  <NoOcurrence />
                </div>
              )}
            </div>
          ) : (
            <div className="mt-3 ">
              <NoOcurrence />
            </div>
          )}
        </>
      ) : (
        <div className="mt-4 rounded-xl border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-800">
          Resultado da CNDT indisponível para esta consulta.
        </div>
      )}
    </section>
  );
}
